var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignLinksBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 158,
    viewBox: "0 0 220 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H220V134C220 134 202.783 158 110 146C17.2174 134 0 158 0 158V0Z",
    fill: "#eff3fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignLinksBackground);
export default __webpack_public_path__ + "static/media/design-links-background.ca8b66d677631bffa133dc8bb905010c.svg";
export { ForwardRef as ReactComponent };